<template>
<div class="page3">
   <div class="box">
     <div style="width: 71%;min-width: 204px;">为商业项⽬提供专属企鹅智慧⼩程序，涵盖会员管理、积分管理、商城管理、卡券管理、活动管理、营销管理、资讯管理、停⻋管理、消息通知管理在内的全系列智慧零售管理平台；并与线下商业管理系统进⾏集成。</div>
   </div>
  <div class="box1"><img src="../../assets/img/h3.png" alt=""></div>
  <div class="box2 lll"><img class="ert" src="../../assets/img/ht1.jpg" alt=""></div>
  <div class="box3 lll"><img class="ert" src="../../assets/img/ht2.jpg" alt=""></div>
  <div class="box4 lll"><img  class="ert" src="../../assets/img/ht3.jpg" alt=""></div>


</div>
</template>
<script>
export default {
  name: "page3",
  data () {
    return {

    };
  }
}
</script>
<style scoped>
  html{
    font-size:1vw;
  }
.box{
    font-size: 0.832rem;
        line-height: 1.664rem;

        text-align: left;
       width: 39.5%;
       margin-top: 3.016rem;
       position:relative ;
}
.box1{
  width: 27.5%;
  height: 9.36rem;
  margin-top: 0.832rem;
}
.lll{
  width: 22.3%;
  height: 12.688rem;
}

.page3 img{
  width: 100%;
}
.box2{
  position: absolute;
  top: 18rem;
  left: 31%;
}
.box3{
  position: absolute;
  top: 15.504rem;
  left: 56%;
}
.box4{
  position: absolute;
 top: 13.2rem;
  right: -3.5%;
}
.ert{
  border: 4px solid #000000;
  border-radius: 10px;
 height: 25.636rem;
}
</style>



// WEBPACK FOOTER //
// src/components/page/page3.vue